<template>
    <div class="home">
        <home-nav></home-nav>
        <home-carousel :carouselList="carouselList"></home-carousel>
        <!--<home-listing></home-listing>-->
        <!--<home-team></home-team>-->
        <div class="home-listing">
            <div class="home-listing-box">
                <div class="home-listing-area"
                     v-for="(item, index) in homeListing"
                     :key="index"
                     @click="homeListClick(index)"
                >
                    <div class="area-top">
                        <img :src="item.icon" alt="">
                        <span>{{ item.text }}</span>
                    </div>
                    <p class="area-detail">
                        <span v-for="(itemIn, idx) in item.detailListIn" :key="idx">{{ itemIn.textIn }}</span>
                    </p>
                    <div class="area-btn-text" @click="fourToDetail(index)">
                        {{ item.btnText }}
                    </div>
                </div>
            </div>
        </div>
        <div class="home-team">
            <div class="home-team-box">
                <p class="home-team-title">
                    {{ cityName }}车队
                </p>
                <p class="home-team-normal">
                    52万+车队任您选择，各种车型，满足您多场景用车
                </p>
                <div class="home-team-car">
                    <div v-if="getsaveLocalCd.length"
                         class="home-team-car-list"
                         v-for="(item, index) in getsaveLocalCd"
                         :key="index"
                         @click="toDetail(item.id,item.company_name)"
                    >
                        <div class="car-img">
                            <img :src="item.company_pic" alt="">
                        </div>
                        <div class="car-bottom">
                            <p class="team-name">
                                {{ item.company_name }}
                            </p>
                            <div class="team-bottom">
                                <div class="team-star">
                                    <el-rate
                                            v-model="item.star"
                                            disabled
                                            text-color="#ff9900"
                                            :colors=scoreColors
                                            disabled-void-color="#888"
                                            score-template="{item.star}">
                                    </el-rate>
                                </div>
                                <div class="team-evaluate">
                                    <span>{{ item.all_comments ? item.all_comments : 0 }}</span>条评价
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!getsaveLocalCd.length" class="zanwuchedui">
                        <img class="zanwuchedui-img" src="@/assets/images/index/null_car.png" alt="">
                        <div class="zanwuchedui-text">暂无相关车队</div>
                    </div>
                </div>

                <div class="team-more" v-if="getsaveLocalCd.length">
                    <span @click="toCharter()">查看更多车队</span>
                </div>
            </div>
        </div>
        <home-process></home-process>
        <home-model :carList="carList" @carTypeChange="carTypeChange"></home-model>
        <home-info :signList="infoList" @signTypeChange="signTypeChange"></home-info>
        <div class="advice">
            <div class="advice-box" @click="toJoin()">
                <img src="@/assets/images/index/home_img_guanggao.png" alt="">
            </div>
        </div>
        <home-service></home-service>
        <home-footer></home-footer>

        <left-code></left-code>
        <right-list></right-list>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import HomeCarousel from './components/homeCarousel';
    // import HomeListing from './components/homeListing';
    // import HomeTeam from './components/homeTeam';
    import HomeProcess from './components/homeProcess';
    import HomeModel from './components/homeModel';
    import HomeInfo from './components/homeInfo';
    import HomeService from './components/homeService';
    import HomeFooter from '@/components/homeFooter';

    import LeftCode from '@/components/leftCode';
    import RightList from "@/components/rightList";

    import {mapState, mapGetters} from 'vuex';

    export default {
        name: 'Home',
        components: {
            homeNav,
            HomeCarousel,
            // HomeListing,
            // HomeTeam,
            HomeProcess,
            HomeModel,
            HomeInfo,
            HomeService,
            HomeFooter,
            LeftCode,
            RightList,
        },
        data() {
            return {
                homeListing: [
                    {
                        icon: require('@/assets/images/index/home_icon_function01.png'),
                        text: '免费报价',
                        detailListIn: [
                            {
                                textIn: '平台大数据积累'
                            },
                            {
                                textIn: '按照行程公里数详细报价'
                            },
                            {
                                textIn: '算算包车要花多少钱'
                            }
                        ],
                        btnText: '开始计算'
                    },

                    {
                        icon: require('@/assets/images/index/home_icon_function02.png'),
                        text: '定制行程',
                        detailListIn: [
                            {
                                textIn: '海量专属路线设计'
                            },
                            {
                                textIn: '各家车队在线报价'
                            },
                            {
                                textIn: '不错过风景  让包车更省心'
                            }
                        ],
                        btnText: '前往定制'
                    },

                    {
                        icon: require('@/assets/images/index/home_icon_function03.png'),
                        text: '包车资讯',
                        detailListIn: [
                            {
                                textIn: '盘点那些包车路上的趣事'
                            },
                            {
                                textIn: '掌握平台的优惠活动'
                            },
                            {
                                textIn: '尽在资讯中'
                            }
                        ],
                        btnText: '来看看吧'
                    },

                    {
                        icon: require('@/assets/images/index/home_icon_function04.png'),
                        text: '安全保障',
                        detailListIn: [
                            {
                                textIn: '平台提供专业保障'
                            },
                            {
                                textIn: '7*24小时在线服务'
                            },
                            {
                                textIn: '包车更省时/省心/安心'
                            }
                        ],
                        btnText: '了解详情'
                    }
                ],

                scoreColors: ['#FF5227', '#FF5227', '#FF5227'], // 车队列表
                carouselList: [], // 首页轮播图
                carType: 59, // 车型展示类型--默认40-59座
                teamList: [],
                carList: [], // 车型展示列表
                cateId: 1, // 新闻资讯类型-默认大巴
                infoList: [], // 新闻资讯
            }
        },
        mounted() {
            /*this.axios.all([this.getIndexCarousel(), this.getIndexCarShow()]).then(axios.spread(function (userResp, reposResp) { // 上面两个请求都完成后，才执行这个回调方法
                console.log(userResp, reposResp);
            }));*/
            var that = this;
            that.getIndexCarousel();
            that.getIndexCarShow();
            that.getInforSign(that.cateId);
            window.scrollTo(0, 0);
        },
        computed: {
            ...mapState({
                localTeam: state => state.localTeam,
                cityName: state => state.cityName,
            }),
            ...mapGetters(['getsaveLocalTeam','getsaveLocalCd'])
        },
        methods: {
            // 获取轮播图
            getIndexCarousel() {
                var that = this;
                that.$axios.post('/indexCarousel', {
                    set_type: 1
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.carouselList = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新', {icon: 2});
                        this.$message('系统错误，请刷新');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            // 获取车型展示
            getIndexCarShow() {
                var that = this;
                that.$axios.post('/indexCarShow', {
                    car_type: that.carType
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.carList = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新', {icon: 2});
                        this.$message('系统错误，请刷新');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            // 获取新闻资讯
            getInforSign(cate_id) {
                var that = this;
                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff']
                    })
                });*/

                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                that.$axios.post('/informationList', {
                    cate_id: cate_id,
                    page: 1
                }).then((res) => {
                    // layer.closeAll();
                    loading.close();
                    res = res.data;
                    if (res.status == 200) {
                        that.infoList = res.data.data;
                    } else {
                        // layer.msg('系统错误，请刷新', {icon: 2});
                        this.$message('系统错误，请刷新');
                    }
                }).catch((error) => {
                    // layer.closeAll();
                    loading.close();
                    console.log(error);
                });
            },
            homeListClick(idx) {
                // 订制行程
                /*if (idx == 1) {
                    this.$router.push({name: 'Quotation'});
                }*/
            },

            // 免费报价、定制行程等点击事件
            fourToDetail(index) {
                if (index == 0) {
                    this.$router.push({path: 'offer'});
                } else if (index == 1) {
                    this.$router.push({name: 'Charter'});
                } else if (index == 2) {
                    this.$router.push({name: 'Information'});
                } else {
                    this.$router.push({path: 'about'});
                }
            },

            // 跳转车队详情
            toDetail(id, teamName) {
                var that = this;
                // this.$router.push({path: "/charterDetails", query: {id: id, teamName: teamName}})
                that.$router.push({path: '/CharterDetails', query: {id: id, teamName: teamName}});
            },
            // 查看更多车队
            toCharter() {
                this.$router.push({name: 'Charter'});
            },
            // 车薪展示切换
            carTypeChange(num) {
                var that = this;
                if (num == 0) {
                    that.carType = 20;
                } else if (num == 1) {
                    that.carType = 40;
                } else if (num == 2) {
                    that.carType = 59;
                }

                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                that.$axios.post('/indexCarShow', {
                    car_type: that.carType
                }).then((res) => {
                    res = res.data;
                    loading.close();
                    if (res.status == 200) {
                        that.carList = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新', {icon: 2});
                        this.$message('系统错误，请刷新');
                    }
                }).catch((error) => {
                    loading.close();
                    console.log(error);
                });
            },

            // 文章资讯切换
            signTypeChange(num) {
                var that = this;
                if (num == 0) {
                    that.cateId = 1;
                    that.getInforSign(that.cateId);
                } else if (num == 1) {
                    that.cateId = 2;
                    that.getInforSign(that.cateId);
                } else if (num == 2) {
                    that.$router.push({name: 'Information'});
                }
            },

            toJoin() {
                this.$router.push({path: '/join'});
            }
        },
    }
</script>

<style scoped>
    @import './home.css';

    .advice {
        width: 100%;
        min-width: 1200px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
    }

    .advice-box {
        width: 1200px;
        height: 100px;
        cursor: pointer;
    }

    .advice-box img {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue